import React from 'react';

const InPageScrollLink = ({to, children, onClick}) => (
  <a href={to} onClick={onClick}>{children}</a>
)

export default InPageScrollLink;
